module.exports = __webpack_public_path__ + "static/media/play.ea8363ea.svg";